import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a odometer icon
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <OdometerIcon width={12} />
 */
const OdometerIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M6.664 13.32c-0.355 0-0.615 0.136-0.784 0.409-0.168
            0.273-0.257 0.699-0.268 1.28v1.845c0 0.62 0.084 1.080 0.252 1.379 0.169
             0.301 0.439 0.452 0.811 0.452 0.368 0 0.635-0.144 0.797-0.432 0.164-0.289
             0.249-0.731 0.255-1.325v-1.804c0-0.629-0.085-1.087-0.257-1.373s-0.44-0.431-0.805-0.431z`}
        />
        <path
            d={`M14.664 13.32c-0.355 0-0.616 0.136-0.784 0.409s-0.257
            0.699-0.268 1.28v1.845c0 0.62 0.085 1.080 0.252 1.379 0.169 0.301 0.439
            0.452 0.811 0.452 0.368 0 0.635-0.144 0.797-0.432 0.164-0.289 0.248-0.731
            0.255-1.325v-1.804c0-0.629-0.085-1.087-0.257-1.373s-0.44-0.431-0.805-0.431z`}
        />
        <path
            d={`M28 8h-24c-1.467 0-2.667 1.2-2.667 2.667v10.667c0 1.467
            1.2 2.667 2.667 2.667h24c1.467 0 2.667-1.2 2.667-2.667v-10.667c0-1.467-1.2-2.667-2.667-2.667zM9.232
            16.659c0 1.048-0.217 1.851-0.651 2.407s-1.069 0.833-1.907 0.833c-0.827
            0-1.459-0.273-1.896-0.817-0.437-0.545-0.661-1.327-0.672-2.344v-1.396c0-1.060
            0.22-1.863 0.659-2.412 0.44-0.549 1.072-0.823 1.899-0.823s1.459 0.272 1.896
            0.815c0.437 0.543 0.661 1.323 0.672 2.341v1.396zM17.232 16.659c0 1.048-0.217
            1.851-0.651 2.407s-1.069 0.833-1.907 0.833c-0.827
            0-1.459-0.273-1.896-0.817-0.437-0.545-0.661-1.327-0.672-2.344v-1.396c0-1.060
            0.22-1.863 0.659-2.412 0.44-0.549 1.072-0.823 1.899-0.823s1.459 0.272 1.896
            0.815c0.437 0.543 0.661 1.323 0.672 2.341v1.396zM28.005 20.007c0 0.733-0.6
            1.333-1.333 1.333h-5.333c-0.733 0-1.333-0.6-1.333-1.333v-8c0-0.733 0.6-1.333
            1.333-1.333h5.333c0.733 0 1.333 0.6 1.333 1.333v8z`}
        />
        <path
            d={`M26.565 16.659c0 1.048-0.217 1.851-0.651 2.407-0.433
            0.555-1.069 0.833-1.907 0.833-0.827
            0-1.459-0.273-1.896-0.817-0.437-0.545-0.661-1.327-0.672-2.344v-1.396c0-1.060
            0.22-1.863 0.659-2.412 0.44-0.549 1.072-0.823 1.899-0.823s1.459 0.271 1.896
            0.815c0.437 0.543 0.661 1.323 0.672 2.341v1.396zM25.060
            15.124c0-0.629-0.085-1.087-0.257-1.373s-0.44-0.429-0.805-0.429c-0.355 0-0.616
            0.136-0.784 0.409-0.168 0.272-0.257 0.699-0.268 1.28v1.845c0 0.619 0.084
            1.079 0.252 1.379 0.168 0.301 0.439 0.452 0.811 0.452 0.368 0 0.635-0.144
            0.797-0.433 0.164-0.288 0.249-0.729 0.255-1.324v-1.805z`}
        />
    </SvgIcon>
)

OdometerIcon.defaultProps = defaultProps

export { OdometerIcon }
